"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e){return"string"==typeof e};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/modals/~/@vds-core/scrollbars/cjs/utils/isString.js
// module id = 1071
// module chunks = 0